<template>
  <div class="addReceipt">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('receivablesManage.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <BasicInfo
            :canEdit="canEdit"
            :departmentList="departmentList"
            @getDepartment="getDepartment"
            @getCompanyCode="getCompanyCode"
            @updateFormData="updateFormData"
            @getRate="getRate"
            @originReceiveMoneyAmountFoo="originReceiveMoneyAmountFoo"
            ref="basicInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('receivablesManage.collapseTitle.receivablesTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <ReceivablesInfo
            :canEdit="canEdit"
            :companyCode="companyCode"
            :receiveStatus="allDetail.receiveStatus"
            @resetCompany="resetCompany"
            @getAmountData="getAmountData"
            @updateFormData="updateFormData"
            @getRate="getRate"
            ref="receivablesInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('receivablesManage.collapseTitle.receivablesClaimTitle') }}
          </div>
        </template>
        <div class="collapse-content padding0">
          <el-tabs type="border-card" v-model="activeNameTab">
            <!-- 一次认领 -->
            <el-tab-pane
              :label="this.$t('receivablesManage.tabTitle.firstClaimsTitle')"
              name="first"
            >
              <FirstClaim
                :formData="formData"
                :departmentList="departmentList"
                :canEdit="canEdit"
                :firstUnClaimedAmount="firstUnClaimedAmount"
                ref="firstClaim"
              />
            </el-tab-pane>
            <!-- 财务凭证 -->
            <el-tab-pane
              :label="this.$t('receivablesManage.tabTitle.accountingVoucherTitle')"
              name="voucherTab"
            >
              <voucher
                ref="voucher"
                :voucherList="voucherList"
                @reverseInfo="reverseInfo"
                @postInfo="postInfo"
              ></voucher>
            </el-tab-pane>
            <!-- 代付凭证 -->
            <el-tab-pane label="代付凭证" name="voucherTab1">
              <voucher
                ref="voucher1"
                :voucherList="voucherList1"
                @reverseInfo="reverseInfo"
                @postInfo="postInfo"
              ></voucher>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-if="this.$route.name.indexOf('details') != -1"
        v-hasPermi="['2021042916195688548']"
        :disabled="receiveResource != '04' || accountingStatus != 'notgenerate'"
        @click="canEdit = !canEdit"
        >{{ $t('functionBtn.editToggle') }}
      </el-button>
      <el-button
        type="primary"
        @click="save('04')"
        v-hasPermi="['2021042916201864324']"
        :disabled="!canEdit"
        class="fixed-bottom-btn"
        >{{ $t('receivablesManageList.button.save') }}</el-button
      >
      <!-- 生成凭证 -->
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916204055616']"
        @click="handleAccountEntry()"
        >{{ this.$t('addInvoice.btns.accountEntry') }}</el-button
      >
      <!-- 过账凭证 -->
      <el-button
        type="primary"
        @click="_doSyncVoucherForEntityData()"
        v-hasPermi="['2021042916210459709']"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        @click="writeOffPay()"
        v-hasPermi="['2021042916212635370']"
        >收款单冲销</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916214940271']"
        @click="handleAnotherPayAccountEntry()"
        >生成代付凭证</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916220915200']"
        @click="doSyncVoucherForEntityDataAnother()"
        >过账代付凭证</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916225015984']"
        @click="writeOffAnotherPay()"
        >代付凭证冲销</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/receivablesManage';
  import BasicInfo from '../components/basicInfo'; // 基本信息
  import ReceivablesInfo from '../components/receivablesInfo'; // 收款信息
  import FirstClaim from '../components/firstClaim'; // 一次认领信息
  // import qs from 'qs';
  import voucherMixins from '@/common/mixins/voucher.js';
  import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'addReceipt',
    mixins: [voucherMixins],
    components: {
      BasicInfo, // 基本信息
      ReceivablesInfo, // 收款信息
      FirstClaim, // 一次认领信息
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        name: 'claim',
        voucherList1: [], //其他凭证
        activeNames: ['0', '1', '2'],
        allDetail: { receiveStatus: null },
        companyCode: null,
        canEdit: true,
        firstUnClaimedAmount: {
          originProformaInvoiceAmount: null, // 形式发票金额
          localProformaInvoiceAmount: null, // 形式发票金额（本币）
          originReceiveMoneyAmount: null, // 收款金额
          localReceiveMoneyAmount: null, // 收款金额（本币）
          originDomesticBankDeductFee: null, // 国内银行扣费
          localDomesticBankDeductFee: null, // 国内银行扣费（本币）
          originForeignBankDeductFee: null, // 国外银行扣费
          localForeignBankDeductFee: null, // 国外银行扣费（本币）
        },
        formData: {},
        departmentList: [], // 部门

        voucherFlag: ['AE_AR_RECEIPTS', 'AE_AR_ANOTHERPAY_RECEIPTS'], //凭证标识
        billIdOld: null, // 初始化票据id
        billAmountOld: null, // 初始化票据金额合计
        receiveResource: null, // 收款来源
        accountingStatus: null, // 入账状态
      };
    },
    mounted() {
      this.companyCode = this.$route.query.companyCode
        ? this.$route.query.companyCode
        : this.userInfo.companyCode;
      this.getDepartment(this.companyCode);
      if (this.$route.name.indexOf('details') != -1) this.canEdit = false; // 详情
    },
    methods: {
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.$route.query.id) {
              this.getDetail();
            }
          }
        } else {
          this.departmentList = [];
        }
      },
      async getDetail() {
        // 请求详情
        this.loading.startLoading();
        const params = {
          id: this.$route.query.id,
        };
        let res = await this.$axios.get(API.QUERY_COLLECTIONORDER_BY_ID, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            let allDetail = res.data.data;
            this.accountingStatus = allDetail.accountingStatus;
            this.receiveResource = allDetail.receiveResource;
            this.billIdOld = allDetail.billId;
            this.billAmountOld = allDetail.originReceiveMoneyAmount;
            this.allDetail = res.data.data;
            ['basicInfo', 'receivablesInfo'].forEach((item) => {
              // 表单信息初始化
              let baseData = this.$refs[item].baseData;
              Object.keys(baseData).map((i) => {
                if (i.indexOf('is') == 0) {
                  return (baseData[i] = allDetail[i] == 'Y' ? true : false);
                } else {
                  return (baseData[i] = allDetail[i]);
                }
              });
            });
            // ["basicInfo", "receivablesInfo"].map((item) => {
            //   // 表单信息初始化
            //   let baseData = this.$refs[item].baseData;
            //   Object.keys(baseData).map((i) => {
            //     if (i.indexOf("is") == 0) {
            //       return baseData[i] = allDetail[i] == "Y" ? true : false;
            //     } else {
            //       return baseData[i] = allDetail[i];
            //     }
            //   });
            // });
            this.getAmountData();
            this.$refs.firstClaim.tableData = allDetail.fundCollectionFirstClaimList; // 一次认领
            this.entityDataId = allDetail.id; // 获取凭证ID 获取凭证列表
            this.getAccountEntry();
          }
        }
      },
      updateFormData() {
        // 获取表单数据
        this.formData = {
          ...this.$refs.basicInfo.baseData,
          ...this.$refs.receivablesInfo.baseData,
        };
      },
      getAmountData() {
        // 获取基本信息
        let receivablesInfo = this.$refs.receivablesInfo.baseData;
        Object.keys(this.firstUnClaimedAmount).map((item) => {
          return (this.firstUnClaimedAmount[item] = receivablesInfo[item]);
        });
      },
      async save(btnType) {
        // 保存
        let basicInfo = this.$refs['basicInfo'].exportChildData(btnType);
        let receivablesInfo = this.$refs['receivablesInfo'].exportChildData(btnType);
        let firstClaimInfo = await this.$refs.firstClaim.exportChildData();
        if (basicInfo && receivablesInfo && firstClaimInfo) {
          if (['SK03', 'SK04'].indexOf(basicInfo.receiveMethod) != -1) {
            if (this.billIdOld == basicInfo.billId) {
              if (this.billAmountOld != receivablesInfo.originReceiveMoneyAmount) {
                return this.tips(
                  `amountValidByBill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}Amount`,
                  'error'
                );
              }
            } else {
              let billSelArr = this.$refs.basicInfo.billSelArr;
              let receiveMethod = basicInfo.receiveMethod;
              let statusFlag = false;
              billSelArr.map((item) => {
                if (item.billStatus != (receiveMethod == 'SK03' ? '03' : '05')) {
                  statusFlag = true;
                }
              });
              if (statusFlag) {
                return this.tips(
                  `billStatusNot${basicInfo.receiveMethod == 'SK03' ? 'Discount' : 'Collection'}`,
                  'error'
                );
              }
              let billTotalAmount = this.calcOriginReceiveMoneyAmount(billSelArr, receiveMethod);
              if (billTotalAmount == 0) {
                return this.tips(
                  `bill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}AmountEmpty`,
                  'error'
                );
              } else if (billTotalAmount != receivablesInfo.originReceiveMoneyAmount) {
                return this.tips(
                  `amountValidByBill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}Amount`,
                  'error'
                );
              }
            }
          }
          let params = {
            ...basicInfo,
            createPersonNo: basicInfo.registerCreatePersonNo, // 制单人
            createPersonName: basicInfo.registerCreatePersonName, // 制单人名称
            ...receivablesInfo,
            ...firstClaimInfo,
          };
          params = this.$baseRequest.assignObj(params);
          this.saveData(params, 'SAVE_COLLECTIONORDER');
        }
      },
      async saveData(params, apiName) {
        this.loading.startLoading();
        let res = await this.$axios.post(API[apiName], params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.returnPath();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      handleAnotherPayAccountEntry() {
        // 生成代付凭证
        if (!this.allDetail.anotherPay) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '没有代付信息',
          });
          return;
        }
        this.$refs.voucher.accoutForm.postDate = null;
        this.$refs.voucher.dialogAccountVisible = true;
        this.voucherIndex = 1;
      },
      doSyncVoucherForEntityDataAnother() {
        //过账代付凭证
        if (!this.allDetail.anotherPay) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '没有代付信息',
          });
          return;
        }
        this.voucherIndex = 1;
        this.doSyncVoucherForEntityData({
          entityDataId: this.allDetail.anotherPay.id,
          entityCode: 'AE_AR_ANOTHERPAY_RECEIPTS',
        });
      },
      _doSyncVoucherForEntityData() {
        //过账凭证
        this.voucherIndex = 0;
        this.doSyncVoucherForEntityData();
      },
      writeOffAnotherPay() {
        // 代付凭证冲销
        this.$refs.voucher.dialogFormVisible = true;
        this.voucherIndex = 1;
      },
      writeOffPay() {
        this.$refs.voucher.dialogFormVisible = true;
        this.voucherIndex = 0;
      },
      getCompanyCode(val) {
        // 获取公司代码
        this.companyCode = val;
        this.$refs.receivablesInfo.resetPayer();
        this.$refs.receivablesInfo.getLoaclCurrency(val);
      },
      resetCompany() {
        // 重置公司信息
        this.companyCode =
          this.$refs.basicInfo.baseData.registerCompanyCode =
          this.$refs.basicInfo.baseData.registerCompanyName =
            null;
        this.$refs.departmentList = [];
      },
      calcOriginReceiveMoneyAmount(val, receiveMethod) {
        let subtrahend;
        if (val && val.length > 0) {
          val.map((item) => {
            if (receiveMethod == 'SK03' && item.fundBillDiscount) {
              subtrahend = this.$cal.calCommon(
                item.fundBillDiscount.discountIncomeAmount,
                subtrahend,
                '+',
                'amount'
              );
            } else if (receiveMethod == 'SK04') {
              subtrahend = this.$cal.calCommon(item.billAmount, subtrahend, '+', 'amount');
            } else if (receiveMethod == 'SK06') {
              subtrahend = null;
            } else if (receiveMethod == 'SK07') {
              subtrahend = this.$cal.calCommon(item.acceptAmount, subtrahend, '+', 'amount');
            }
          });
        }
        return subtrahend;
      },
      originReceiveMoneyAmountFoo(val, receiveMethod) {
        this.$refs.receivablesInfo.baseData.originReceiveMoneyAmount =
          this.calcOriginReceiveMoneyAmount(val, receiveMethod);
      },
      async getRate() {
        //获取汇率
        let basicInfo = this.$refs.basicInfo.baseData;
        let receivablesInfo = this.$refs.receivablesInfo.baseData;
        if (
          basicInfo.registerDate &&
          receivablesInfo.receiveInfoCurrencyCode &&
          receivablesInfo.basicInfoCurrencyCode &&
          receivablesInfo.exchangeType
        ) {
          const params = {
            fromCurrencyCode: receivablesInfo.receiveInfoCurrencyCode,
            toCurrencyCode: receivablesInfo.basicInfoCurrencyCode,
            exchangeType: receivablesInfo.exchangeType,
            exchangeDate: basicInfo.registerDate,
          };
          if (params.fromCurrencyCode != params.toCurrencyCode) {
            let res = await this.$baseRequest.getRate(params);
            if (res) {
              receivablesInfo.exchangeRate = res.positiveRate;
            } else {
              this.$message({
                showClose: true,
                message: this.$t('receivablesManage.message.rateInfo'),
                type: 'error',
              });
              // receivablesInfo.receiveInfoCurrencyCode =
              // receivablesInfo.receiveInfoCurrencyName =
              receivablesInfo.exchangeRate = 1;
            }
          } else {
            receivablesInfo.exchangeRate = 1;
          }
        } else {
          receivablesInfo.exchangeRate = 1;
        }
        this.$refs.receivablesInfo.calcLocalAmountAll();
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/capital/receiptManage',
            name: 'receiptManage',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .addReceipt {
    .collapse-main-content {
      padding-bottom: 80px;
    }
    .padding0 {
      padding: 0;
    }
  }
</style>
